<div *ngIf="title" class="section-title bold" [ngClass]="{ 'section-title--isDetail': isDetail }">{{ title }}</div>
<ng-content></ng-content>
